<template>
  <div class="button-container">
    <template v-if="loading">
        <div class="skeleton-card">
          <div class="skeleton skeleton-icon"></div>
          <div class="skeleton skeleton-text"></div>
          <div class="skeleton skeleton-desc"></div>
        </div>
      </template>
      <template v-else>
        <a :href="link" target="_blank" class="image-button">
          <template v-if="iconIsEmoji">
            <span class="button-emoji">{{ icon }}</span>
          </template>
          <template v-else>
            <img :src="icon" alt="Button Image" class="button-image"/>
          </template>
          <span class="button-text">{{ text }}</span>
        </a>
        <p class="button-description">{{ description }}</p>
      </template>
    </div>
</template>
  
  <script>
  export default {
    name: 'ServerComponent',
    props: {
      loading: {
        type: Boolean,
        default: false
      },
    icon: {
      type: String,
      required: true
    },
    iconIsEmoji: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  }
  }
  </script>
  
  <style scoped>
.button-container {
  text-align: center;
  margin-bottom: 20px;
  width: 240px;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 10px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
}

.image-button {
  display: flex;
  align-items: center;
  background-color: var(--color-primary);
  color: var(--color-on-primary);
  text-decoration: none;
  padding: 10px 15px;
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.12);
  transition: transform 0.12s ease, box-shadow 0.12s ease;
  width: 100%;
  box-sizing: border-box;
  overflow: hidden;
}

.image-button:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0,0,0,0.14);
}

.button-image {
  width: 30px;
  height: 30px;
  margin-right: 10px;
  flex-shrink: 0;
}

.button-emoji {
  font-size: 28px;
  line-height: 1;
  width: 30px;
  height: 30px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin-right: 10px;
  flex-shrink: 0;
}

.button-text {
  font-size: 16px;
  font-weight: bold;
  text-align: left;
  flex-grow: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.button-description {
  font-size: 14px;
  color: #555;
  margin-top: 10px;
  text-align: left;
}
  </style>
  
  <style scoped>
  .skeleton-card { display:flex; flex-direction:column; gap:8px; align-items:flex-start; padding:10px; width:220px; }
  .skeleton { background: linear-gradient(90deg,#eee,#f6f6f6,#eee); border-radius:6px; }
  .skeleton-icon { width:40px; height:40px; }
  .skeleton-text { width:140px; height:16px; }
  .skeleton-desc { width:180px; height:12px; }
  </style>
  